/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable @next/next/no-img-element */
import Link from "next/link";
import { ReactElement } from "react";

import ReactDOMServer from "react-dom/server";
import Parse, {
  HTMLReactParserOptions,
  DOMNode,
  Element,
} from "html-react-parser";

import { FaLink } from "react-icons/fa";

const isElement = (domNode: DOMNode): domNode is Element => {
  const isTag = domNode.type === "tag";
  const hasAttributes = (domNode as Element).attribs !== undefined;

  return isTag && hasAttributes;
};

// const getYoutubeId = (url: string) => {
//   if (!url) return null;
//   const res = url.match(
//     /(?:https?:\/\/)?(?:www\.|m\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\/?\?v=|\/embed\/|\/)([^\s&\?\/\#]+)/
//   );
//   return res ? res[1] : null;
// };

// const playYoutube = (target: any, youtubeId: string) => {};

let heading2Index = 0;
let heading3Index = 0;

const parseRichText = (html: string) => {
  const parserOptions: HTMLReactParserOptions = {
    replace: (domNode) => {
      if (isElement(domNode) && domNode.name === "h2") {
        domNode.attribs.id = `chapter${heading2Index}`;
        heading2Index++;
      }

      if (isElement(domNode) && domNode.name === "h3") {
        domNode.attribs.id = `subchapter${heading3Index}`;
        heading3Index++;
      }

      if (isElement(domNode) && domNode.name === "img" && domNode.attribs.src) {
        return (
          <figure className="nextimg">
            <img src={domNode.attribs.src} alt={domNode.name} loading="lazy" />
          </figure>
        );
      }

      // if (
      //   isElement(domNode) &&
      //   domNode.name === "iframe" &&
      //   domNode.attribs.class === "ql-video"
      // ) {
      //   const youtubeId = getYoutubeId(domNode.attribs.src);
      //   if (!youtubeId) return;

      //   return (
      //     <div className="embedVideo">
      //       <img
      //         onClick={(e) => playYoutube(e.target, youtubeId)}
      //         src={`https://i.ytimg.com/vi/${youtubeId}/maxresdefault.jpg`}
      //         alt={youtubeId}
      //         loading="lazy"
      //         width="1280"
      //         height="720"
      //       />
      //       <div />
      //     </div>
      //   );
      // }

      if (isElement(domNode) && domNode.name === "a" && domNode.attribs.href) {
        const href = domNode.attribs.href;
        const isExternal =
          new URL(href).origin !== process.env.NEXT_PUBLIC_WEB_URL;

        return (
          <div className="articleLink">
            {isExternal ? (
              <a
                href={href}
                target={isExternal ? "_blank" : "_self"}
                rel={isExternal ? "nofollow noreferrer noopener ugc" : ""}
              >
                <FaLink />
                <dl>
                  <dt>{(domNode.children[0] as any).data}</dt>
                  <dd>{href}</dd>
                </dl>
              </a>
            ) : (
              <Link href={href} prefetch={false}>
                <a>
                  <FaLink />
                  <dl>
                    <dt>{(domNode.children[0] as any).data}</dt>
                    <dd>{href}</dd>
                  </dl>
                </a>
              </Link>
            )}
          </div>
        );
      }

      return domNode;
    },
  };

  const Component = Parse(html, parserOptions) as ReactElement;
  const reactHtml = ReactDOMServer.renderToStaticMarkup(Component);

  return reactHtml;
};

export default parseRichText;
